import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { cloneDeep } from "lodash";
import { ActivatedDetector, BwVersion, Client, ClientApplication, Detectors, DetectSimulation, Policy, RequestPolicy, RequestSimulation, ResultSimulation } from "src/app/service/global.service";
import { AbstractController } from "./abstract-controller";
import { Environment } from "../environment";

export class SecurityPoliciesController extends AbstractController {

    private readonly service:string="policy-management/api/v1.0";
    private readonly apiUrl: keyof Environment = "bwApiUrl";


    public async getPolicies():Promise<Policy[]>{
        return await this.network.get(`${this.service}`+`/policies`, this.apiUrl)
    }

    public async getPolicyById(id:number):Promise<Policy>{
        return await this.network.get(`${this.service}`+`/policies/${id}`, this.apiUrl)
    }

    public async getBWV(os:string | undefined):Promise<BwVersion[]>{
        if(os){
            return await this.network.get(`${this.service}`+`/b-w?os=${os.toLowerCase()}`, this.apiUrl)
        }else{return await this.network.get(`${this.service}`+`/b-w`, this.apiUrl)}
    }

    public async getPoliciesByFilters(lstatus : string[], bwv : string[], clients:string[]):Promise<Policy[]>{
        let request='?'
        for(let s of lstatus){
            request+='status='+s+'&'
        }
        request=request.slice(0,-1)
        if(bwv.length>0){
            request+='&'
            for(let bw of bwv){
                request+="bw-v="+bw+"&"
            }
            request=request.slice(0,-1)
        }
        if(clients.length>0){
            request+='&'
            for(let cli of clients){
                request+="clients="+cli+"&"
            }
            request=request.slice(0,-1)
        }
        return await this.network.get(`${this.service}`+`/policies`+`${request}`, this.apiUrl)
    }

    public async postPolicy(requestPolicy : RequestPolicy){
        return await this.network.post(`${this.service}`+`/policies`,requestPolicy, this.apiUrl)
    }

    public async modifyPolicy(requestPolicy : RequestPolicy){
        return await this.network.put(`${this.service}`+`/policies/${requestPolicy.id}`,requestPolicy, this.apiUrl)
    }

    public async deletePolicy(id:number | undefined){
        return await this.network.delete(`${this.service}`+`/policies/${id}`, this.apiUrl)
    }

    public async patchStatusPolicy(id:number | undefined, body : any){
        return await this.network.patch(`${this.service}`+`/policies/${id}`,body, this.apiUrl)
    }

    public async getAllApplication(policy:Policy|undefined):Promise<ClientApplication[]>{
        return await this.network.get(`${this.service}`+`/applications?os=${policy?.bwVersion?.os}`, this.apiUrl)
    }

    public async requestSimulation(item: {id: number, body:RequestSimulation}):Promise<ResultSimulation>{
        return await this.network.post(`${this.service}`+'/simulate'+`/${item.id}`, item.body, this.apiUrl)
    }

    public async getClients():Promise<Client[]>{
        return await this.network.get(`${this.service}`+'/clients', this.apiUrl)
    }

    public async getClientById(id:number):Promise<Client>{
        return await this.network.get(`${this.service}`+`/clients/${id}`, this.apiUrl)
    }

    public async getApplicationClient(client:Client|undefined):Promise<ClientApplication[]>{
        return await this.network.get(`${this.service}`+`/applications?clientId=${client?.id}`, this.apiUrl)
    }

    public async addClient(client : Client){
        return await this.network.post(`${this.service}`+'/clients', client, this.apiUrl)
    }

    public async addApplication(app:ClientApplication){
        return await this.network.post(`${this.service}`+'/applications', app, this.apiUrl)
    }

    public async deleteClient(client : Client){
        return await this.network.delete(`${this.service}`+'/clients'+`/${client.id}`, this.apiUrl)
    }

    public async deleteApplication(app : ClientApplication){
        return await this.network.delete(`${this.service}`+'/applications'+`/${app.id}`, this.apiUrl)
    }


    //Fonctions Front

    public getAllApp(listPolicies: Policy[]) {
        let lapp: any[] = []
        for (let elem of listPolicies) {
            if (!lapp.includes(elem.clientApplication?.packageName.toLowerCase())) {
                lapp.push(elem.clientApplication?.packageName.toLowerCase())
            }
        }
        return lapp
    }

    public getAllOS(listPolicies: Policy[]) {
        let los: any[] = []
        for (let elem of listPolicies) {
            if (!los.includes(elem?.bwVersion?.os.toLowerCase())) {
                los.push(elem?.bwVersion?.os.toLowerCase())
            }
        }
        return los
    }

    public osApp(listPolicies: Policy[]) {
        let l: any[] = []
        let osL = this.getAllOS(listPolicies)
        let appL = this.getAllApp(listPolicies)

        for (let o of osL) {
            for (let a of appL) {
                l.push([o, a])
            }
        }
        return l
    }

    public getPolicyByAppOS(os: string, app: string, listPolicies: Policy[]) {
        return cloneDeep(listPolicies.filter(v => v.bwVersion?.os.toLowerCase() == os && v.clientApplication?.packageName.toLowerCase() == app))
    }

    public getPolicyByOS(os:string, listPolicies: Policy[]){
        return cloneDeep(listPolicies.filter(v => v.bwVersion?.os.toLowerCase() == os))
    }

    public getPolicyByClient(clientName:string, listPolicies: Policy[]){
        return cloneDeep(listPolicies.filter(policies => policies.clientPolicyDto?.name == clientName ))
    }

    public getAllFamilyofDetectors(policy:Policy | undefined) {
        let l: any[] = []
        policy?.bwVersion?.listDetectors?.forEach(elem => {if(!l.includes(elem?.family)){
          l.push(elem.family)}})
        return l
    }

    public formatStatut(status: string | undefined) {
        if (status) {
            let maj = status[0].toUpperCase() + status.slice(1)
            return "status_" + maj
        }
        else return this.translationService.get('disabled')
    }

    public formatPId(lstatus: string[] | undefined) {
        let format = ''
        if (lstatus && lstatus.length > 0) {
            for (let el of lstatus) {
                let maj = el[0].toUpperCase() + el.slice(1)
                format += maj + " | "
            }
            let f = format.substring(0, format.length - 2)
            return f
        }
        else return this.translationService.get('disabled')

    }
    public notExistValidator(liste: Policy[] | undefined): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
          const value = control.value
          let exist: boolean = true
          if (liste)
            for (let elem of liste) {
              if (elem.name.toLowerCase() === value?.toLowerCase()) {
                exist = false
              }
            }
          return exist ? null : { exist: true }
        }
    }

    public getDetectorsByFamily(policy : Policy | undefined , family : string){
        return policy?.bwVersion?.listDetectors?.filter(detect=> detect.family.toLowerCase()==family.toLowerCase())
    }

    public getFatalLength(activatedDetectors : ActivatedDetector[] | undefined, family: string){
        return activatedDetectors?.filter(elem=>{
            if(elem.policyDetectorId){
                return elem.policyDetectorId.detector.family==family && elem.status=="FATAL"
            }else{return false}
        }
        ).length ?? 0
    }
    public getTotalLength(listDetectors : Detectors[] | undefined , family: string){
        return listDetectors?.filter(elem=> elem.family==family).length ?? 0
    }

    public formatActiveDetectorsToPost(activatedDetectors : ActivatedDetector[] | undefined){
        let newAD=activatedDetectors
        newAD?.forEach(elem=> {
            elem.detectorId=elem.policyDetectorId?.detector.id
            elem.policyDetectorId=undefined
        })
        return newAD
    }


    public parseDetect(objectToParse : Object){
        let ldetect : DetectSimulation[]=[]
        for(let [key, value] of Object.entries(objectToParse)){
             let totalCounter=0;
             for ( let detector of value)
              totalCounter+=detector.occurrence

            let detect: DetectSimulation={
                family:key,
                counter: totalCounter,
                detectors:value,
            }
            ldetect.push(detect)
        }
        return ldetect
    }

    public getAllOsClientApplications(listClientApp: ClientApplication[]){
        let los: any[] = []
        for (let elem of listClientApp) {
            if (!los.includes(elem?.os?.toLowerCase())) {
                los.push(elem?.os?.toLowerCase())
            }
        }
        return los
    }

    public getAppClientByOS(os:string, listClientApp: ClientApplication[]){
        return cloneDeep(listClientApp.filter(v => v?.os?.toLowerCase() == os))
    }

}

export const allFalse: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const c1 = control.get('in_demand');
    const c2 = control.get('periodic');
    return c1 && c2 && !c1.value && c1.value === c2.value ? { allfalse: true } : null;
};

